<template>
<span>
    <span :style="textStyle_" style="white-space:normal;display:block;text-align: center; line-height:150%">{{text}}</span>
</span>
    
</template>
<script>
export default {
    name: 'de-text',
    props: ["textStyle","text","width","lineHeight"],
    computed: {
        textStyle_(){
            return Object.assign({}, this.textStyle, {fontSize:this.textStyle&&this.textStyle.fontSize+'px',width:this.width>0?this.width+'px':'auto',lineHeight:this.lineHeight>0?this.lineHeight+'px':'auto'});
        }
    },
}
</script>